import React from 'react';
import styled from 'styled-components/macro';
import classNames from 'classnames';
import { Link } from 'react-navi';

const Columns = styled.div`
  max-width: 780px;
  margin: 0 auto;
  display: inline-flex !important;
`;

const Button = styled.a`
  width: 100%;
  height: 40px;
`;

export function EntriesNavBar(props: any) {
  return (
    <section className="section has-background-white-bis">
        <div className="container has-text-centered">
            <h1 className="title is-size-5 is-size-6-mobile is-margin-bottom-2 has-text-weight-bold has-text-black">
                候補者一覧
            </h1>
            <Columns className="columns is-mobile is-variable is-2 is-multiline has-text-weight-bold">
                <div className="column">
                    <Button className="button is-gold is-size-7" href="/final">
                        ファイナリスト
                    </Button>
                </div>
                <div className="column">
                    <Button className="button is-silver is-size-7 " href="/semifinal">
                        セミファイナリスト
                    </Button>
                </div>
                <div className="column">
                    <Button className="button is-dark is-size-7 " href="/third">
                        3次審査通過者
                    </Button>
                </div>
                <div className="column">
                    <Button className="button is-dark is-size-7 " href="/second">
                        2次審査通過者
                    </Button>
                </div>
                <div className="column">
                    <Button className="button is-dark is-size-7 " href="/first">
                        1次審査通過者
                    </Button>
                </div>
            </Columns>
        </div>
    </section>
  );
}
